export const calculateFileSize = (sizeInBytes: string | number) => {
  return (Number(sizeInBytes) * 1e-6).toFixed(2);
};
